import React, { useState, useEffect } from 'react';
import { Button, FormControl, Form, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ClipIcon, ContactError } from '../../../../components/Icons';
import { useTranslation } from 'react-i18next';
import GenericUpload from 'components/generic-components/GenericUpload';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getLaravelValidationErrors } from 'helpers';
import { useHistory } from 'react-router';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { sendMessageAction } from 'reducers/profile/profile.actions';
import { LOGIN, PASSWORD_RESET, PRIVACY, ROOT, TERMS } from '../../../../constants/routes';
import NoifyModal from '../../../../components/NotifyModal'
import i18n from 'i18next';

const Contact = () => {
	const [attachment, setAttachment] = useState([]);
	const user = useSelector(selectAuthUser);
	const [correctEmail, setCorrectEmail] = useState(false);
	const ref = React.useRef(null);
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [selectedFile, setSelectedFile] = useState();
	const [isOpen, setIsOpen] = useState(true);

	const history = useHistory();

	//   TODO --- should be changed after actual implementation of an API call.
	// success,setSuccess should be totally removed and the behavior should be determined with the status (formik)
	const [success, setSuccess] = useState(false);

	const handleFileSelect = (e, target) => {
		const file = e.target.files[0];
	    if (attachment.length === 10) return;
		if(e.target.files.length !== 0) {
		setAttachment(prevState => [...prevState, { file, url: URL.createObjectURL(file) }]);
	    }
	};

	const handleFileDelete = url => {
		setAttachment(attachment.filter(attach => attach.url !== url));
	};

	const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

	const { values, status, handleSubmit, setValues, errors, resetForm, touched, handleChange, isSubmitting } = useFormik({
		initialValues: {
			message: '',
			attachments: [],

		},
		validationSchema: Yup.object().shape({
			subject: Yup.string().trim().min(8),
			message: Yup.string().trim().required(i18n.t('Message field is required')),
		}),
		onSubmit: (values,  {  setStatus, setSubmitting }) => {
			setSubmitting(true);
			// setSuccess(true);
			dispatch(sendMessageAction(user.id, {
				...values,
				attachments: attachment ? attachment.map(attach => attach.file) : null
			}))
				.then(resp => {
					setSuccess(true);

					console.log('resp');
				})
				.catch(errors => {
					setStatus({
						errors: getLaravelValidationErrors(errors),
					});
					setSubmitting(false);
					setIsOpen(true);
				});
		},
	});
	const handleClose = () => {
		setIsOpen(false);

	};

	useEffect(() => {
		if (status?.success || success) {
			setTimeout(() => {
				setSuccess(false);

			}, 3000);
		}

	}, [status, success]);
	return (
		<div className="col px-md-5 py-3 contact-wrapper">
			{status && status.success || success ?
				<React.Fragment>
					<div className="contact-success">

						<p className="text-success text-center" style={{ fontSize: '1.1rem' }}>
							{t('Successfully sent!')}
						</p>
					</div>
				</React.Fragment> : ""}
			{

				<>
					<div className="talk-us">
						<p>{t('talk_to_us')}</p>
					</div>
					<Form onSubmit={handleSubmit}>
						<div className="contact-email">
							<p>
								To:
								<span>info@showit.co.il</span>
							</p>
						</div>
						<Form.Group className="my-3">
							<InputGroup size="lg" className="contact-input-group">
								<div className="contact-text-header">{t('subject')}: <span style={{ color: '#fc4f90' }}> *</span></div>
								<FormControl
									type="text"
									className="border-none input-login input-password input-password-account font-size-12"
									name="subject"
									autoComplete="off"
									value={values.subject}
									onChange={handleChange}
									isInvalid={touched.subject && errors.subject}
								/>
								<Form.Control.Feedback type="invalid" tooltip>
									{!!errors.subject && errors.subject}
								</Form.Control.Feedback>
							</InputGroup>
						</Form.Group>
                        
						<Form.Group className="contact-attachments my-3">
							<InputGroup size="lg">

								<GenericUpload
									uploadType="file"
									customClass="main-input"
									uploadLabel="attachments"
									onChange={e => handleFileSelect(e, 'attachments')} ref={ref}
									attachment={attachment}
									handleFileDelete={e => handleFileDelete(e)}
									UploadIcon={ClipIcon}
									name="attachments"
									ref={ref}

									mediaTypes=".jpg,.jpeg,.webp,.gif,.bmp,.png"
								/>
							</InputGroup>
						</Form.Group>
						<Form.Group className={attachment && attachment.length > 0 ? "contact-message_filed my-3" : 'contact-message my-3'}>
							<div className="acc-text-header"><span className="contact-message-attribute">|</span>{t('message')} <span style={{ color: '#fc4f90' }}> *</span></div>
							<InputGroup size="lg">

								<FormControl
									type="text"
									className="border-none input-login input-password input-password-account font-size-12"
									name="message"
									autoComplete="off"
									as="textarea"
									rows={4}
									value={values.message}
									onChange={handleChange}
									isInvalid={touched.message && errors.message}
								/>
								<Form.Control.Feedback type="invalid" tooltip>
									{!!errors.message && errors.message}
								</Form.Control.Feedback>
							</InputGroup>
						</Form.Group>

						{status &&
							status.errors &&
							status.errors.map((err, key) => (

								<NoifyModal key={key} show={isOpen}
									onHide={handleClose} customClass="contact-modal" title={err} />

							))}

						<div className="d-flex contact-btn-wrapper  mt-4">
							<Button
								onClick={() => history.push(ROOT)}
								className="contact-discard contact-btn" >
								{t('discard')}
							</Button>
							<Button
								type="submit"
								disabled={values.subject || values.message || attachment.length > 0 ? '' : true}

								className={values.subject || values.message || attachment.length > 0 ? "contact-btn contact-send text-capitalize" : 'contact-btn disabled-btn text-capitalize'}>
								{t('send')}
							</Button>

						</div>
					</Form>
				</>
			}
		</div >
	);
};

export default Contact;
